import {IAlert} from '../../../../actions/proto';
import {BusinessRuleAction} from '../../../../constants';
import {
    BusinessRuleOpenTask,
    BusinessRuleSendMailEmails,
    BusinessRuleSendMailSendText,
    BusinessRuleSendMailUsers,
    BusinessRuleSendNoti,
    BusinessRuleVerification,
    BusinessRulewebHook
} from '../../../RulesListDialog/consts';
import {priority} from '@priority-software/priority-proto-api/lib';
import {AutomationChoose} from '../../../../reducer/model';
import {TEmailStateType} from '../../../../../EmailEditor/reducer/types';
import {languageTabs} from '../AutomationActionToolbar/constants';
import {imageHTMLProcess} from '../../../../../EmailEditor/utils/imageHTMLProcess';

export const prepareChatboxData = (
    alert: priority.netitems.form.IAlert,
    options: AutomationChoose[],
    isStatusActions: boolean
) => {
    return isStatusActions && !alert.BPM?.TimeValue && !alert.BPM?.TimeField
        ? options.map(item => {
              return item.value === BusinessRuleAction.ChangeStatusTo
                  ? {...item, disabled: true}
                  : item;
          })
        : options;
};

export const getMonitorMessage = (data: IAlert) => {
    switch (data.MessageType) {
        case BusinessRuleAction.EmailMsg:
            if (data.RecipientMail.length > 0) {
                return BusinessRuleSendMailEmails;
            } else if (data.RecipientUser.length > 0) {
                return BusinessRuleSendMailUsers;
            }
            return null;
        case BusinessRuleAction.TextMsg:
            return BusinessRuleSendMailSendText;
        case BusinessRuleAction.OpenTask:
            return BusinessRuleOpenTask;
        case BusinessRuleAction.PushNotification:
            return BusinessRuleSendNoti;
        case BusinessRuleAction.Webhook:
            return BusinessRulewebHook;
        case BusinessRuleAction.UserVerification:
            return BusinessRuleVerification;
        default:
            return null;
    }
};

export const checkingNewEmailTemplateSize = async (newEmailTemplate?: TEmailStateType) => {
    return new Promise<{isContinue: boolean; newEmailTemplate: TEmailStateType}>(async resolve => {
        if (newEmailTemplate) {
            for (const tab of languageTabs) {
                const emailHtml = newEmailTemplate?.[tab.id]?.emailHtml;
                // const editorSubject = newEmailTemplate?.[tab.id]?.editorSubject;
                // console.log('the values from the email editor!', {emailHtml, editorSubject});

                if (emailHtml) {
                    const {html, isOverSize} = await imageHTMLProcess(emailHtml);

                    if (isOverSize) {
                        if (newEmailTemplate) {
                            newEmailTemplate[tab.id] = {
                                ...newEmailTemplate[tab.id],
                                emailHtml: html
                            };
                        }

                        return resolve({isContinue: false, newEmailTemplate});
                    } else {
                        if (newEmailTemplate) {
                            newEmailTemplate[tab.id] = {
                                ...newEmailTemplate[tab.id],
                                emailHtml: html
                            };
                        }
                    }
                }
            }
        }

        return resolve({isContinue: true, newEmailTemplate});
    });
};
